import Vue from "vue";
import VueRouter from "vue-router";

import blogRoutes from "./blog";
import communityRoutes from "./community";
import exploreRoutes from "./explore";
import feedRoutes from "./feed";
import postRoutes from "./post";
import storeRoutes from "./store";
import userRoutes from "./user";
import pageRoutes from "./page";

Vue.use(VueRouter);

const routes = [blogRoutes, communityRoutes, ...exploreRoutes, feedRoutes, postRoutes, storeRoutes, ...pageRoutes, ...userRoutes];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() { // to, from, savedPosition
    return new Promise((resolve) => {
      resolve({ x: 0, y: 0 })
    })
  }

});

export default router;
